import { render, staticRenderFns } from "./StatisticsConfig.vue?vue&type=template&id=eed4221c"
import script from "./StatisticsConfig.vue?vue&type=script&lang=js"
export * from "./StatisticsConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eed4221c')) {
      api.createRecord('eed4221c', component.options)
    } else {
      api.reload('eed4221c', component.options)
    }
    module.hot.accept("./StatisticsConfig.vue?vue&type=template&id=eed4221c", function () {
      api.rerender('eed4221c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/processMonitoring/template/StatisticsConfig.vue"
export default component.exports